import dynamic from 'next/dynamic';
const AllRetailersTastic = dynamic(() => import('./all-retailers'));
const AnnouncementBarTastic = dynamic(() => import('./bar/announcment'));
const CategorySliderTastic = dynamic(() => import('./category-slider'));
const HeroTastic = dynamic(() => import('./content/hero'));
const Tile = dynamic(() => import('./content/tile'));
const TilesGroupTastic = dynamic(() => import('./content/tiles-group'));
const ContentSliderTastic = dynamic(() => import('./content-slider'));
const DividerTastic = dynamic(() => import('./divider'));
const FeaturedProductsTastic = dynamic(() => import('./featured-products'));
const FeaturedRetailersTastic = dynamic(() => import('./featured-retailers'));
const Footer = dynamic(() => import('./footer'));
const GrandParentAllRetailersTastic = dynamic(() => import('./grand-parent-all-retailers'));
const Header = dynamic(() => import('./header'));
const HomeSearchBarTastic = dynamic(() => import('./home-search-bar'));
const LatestFromRetailerTastic = dynamic(() => import('./latest-from-retailer'));
const LeasingStepsContentTastic = dynamic(() => import('./leasing-steps-content'));
const MarketingTileTastic = dynamic(() => import('./marketing-tiles'));
const MobileBottomNavigationTastic = dynamic(() => import('./mobile-bottom-navigation'));
const NotFoundTastic = dynamic(() => import('./not-found'));
const PageHeaderTastic = dynamic(() => import('./page-header'));
const ProductListTastic = dynamic(() => import('./product-list'));
const ProductSlider = dynamic(() => import('./products/slider'));
const PromotionSliderTastic = dynamic(() => import('./promotion-slider'));
const RetailerGrandParentTastic = dynamic(() => import('./retailer-grand-parent'));
const RetailerSuggestions = dynamic(() => import('./retailers-suggestions'));
const SearchTastic = dynamic(() => import('./search'));
const SearchResultTastic = dynamic(() => import('./search-result'));
const ShopRetailerCategoryTastic = dynamic(() => import('./shop-retailer-category'));
const SpacerTastic = dynamic(() => import('./spacer'));
const TopProductsTastic = dynamic(() => import('./top-products'));
const TopRetailersTastic = dynamic(() => import('./top-retailers'));
const GlobalHeaderTastic = dynamic(() => import('./global-header'));
import { TasticRegistry } from './types';

const Markdown = dynamic(() => import('./markdown'));
const Banner = dynamic(() => import('./banner'));
const AccountDetails = dynamic(() => import('./account/details'));
const AccountLogin = dynamic(() => import('./account/login'));
const AccountOrdersHistory = dynamic(() => import('./account/orders'));
const AccountRegister = dynamic(() => import('./account/register'));
const ResetPassword = dynamic(() => import('./account/reset-password'));
const Checkout = dynamic(() => import('./checkout'));
const ThankYou = dynamic(() => import('./thank-you'));
const ProductDetails = dynamic(() => import('./products/details'));
const ProductList = dynamic(() => import('./products/product-list'));
const ProductListAlgolia = dynamic(() => import('./products/product-list-algolia'));
const SimilarProducts = dynamic(() => import('./products/similar-products'));
const OtherProducts = dynamic(() => import('./products/other-products'));
const Showcase = dynamic(() => import('./showcase'));
const Cart = dynamic(() => import('./cart'));
const FilterRetailersTastic = dynamic(() => import('./filter-retailers'));
const FilterProductListTastic = dynamic(() => import('./filter-product-list'));
const FilterPanelTastic = dynamic(() => import('./filter-panel'));
const ContentBannerTastic = dynamic(() => import('./content-banner'));
const CategoryImagesTastic = dynamic(() => import('./category-images'));
const FindEverythingTastic = dynamic(() => import('./find-everything'));
const SimilarCategoryProducts = dynamic(() => import('./products/similar-category-products'));
const ContentfulBlogTastic = dynamic(() => import('./contentful-blog'));
const AffiliateUAPostApprovalLoaderTastic = dynamic(() => import('./affiliate-ua-post-approval-loader'));
const ContentfulPreview = dynamic(() => import('./contentful-preview'));
const HandoffContentfulPreview = dynamic(() => import('./handoff-contentful-preview'));
const CommonFeaturedRetailersTastic = dynamic(() => import('./common-featured-retailers'));
const BlogSearchTastic = dynamic(() => import('./contentful-search-blog'));
const ContentfulBlogSearchTastic = dynamic(() => import('./contentful/contentful-blog-search'));
const BlogContainerTastic = dynamic(() => import('./contentful/blog-container'));
const RetailerDetailContainerTastic = dynamic(() => import('./contentful/retailer-detail-container'));
const CategoryPageContainerTastic = dynamic(() => import('./contentful/category-page-container'));
const ContentfulBlogSearchResultsTastic = dynamic(() => import('./contentful/blog-search-result'));
const ContentfulBlogCategoryPageTastic = dynamic(() => import('./contentful/blog-category-page'));
const ContentContainerTastic = dynamic(() => import('./contentful/content-container'));
const RetailerHandoffContainerTastic = dynamic(() => import('./contentful/retailer-handoff-container'));

export const tastics = {
  'commercetools/ui/checkout': Checkout,
  'commercetools/ui/thank-you': ThankYou,
  'commercetools/ui/footer': Footer,
  'commercetools/ui/header': Header,
  'commercetools/ui/content/tile': Tile,
  'commercetools/ui/content/hero': HeroTastic,
  'commercetools/ui/content/spacer': SpacerTastic,
  'commercetools/ui/content/showcase': Showcase,
  'commercetools/ui/content/markdown': Markdown,
  'commercetools/ui/content/banner': Banner,
  'commercetools/ui/cart': Cart,
  'commercetools/ui/products/details': ProductDetails,
  'commercetools/ui/products/product-list': ProductList,
  'commercetools/ui/products/product-list-algolia': ProductListAlgolia,
  'commercetools/ui/products/slider': ProductSlider,
  'commercetools/ui/products/similar-products': SimilarProducts,
  'commercetools/ui/products/other-products': OtherProducts,
  'commercetools/ui/account/details': AccountDetails,
  'commercetools/ui/account/login': AccountLogin,
  'commercetools/ui/account/register': AccountRegister,
  'commercetools/ui/account/orders': AccountOrdersHistory,
  'commercetools/ui/account/reset-password': ResetPassword,
  'commercetools/ui/category-slider': CategorySliderTastic,
  'commercetools/ui/content/announcement-bar': AnnouncementBarTastic,
  'commercetools/ui/content/content-slider': ContentSliderTastic,
  'commercetools/ui/content/tiles-group': TilesGroupTastic,
  'commercetools/ui/not-found': NotFoundTastic,
  'commercetools/ui/bottom-navigation': MobileBottomNavigationTastic,
  'commercetools/ui/marketing-tiles': MarketingTileTastic,
  'commercetools/ui/featured-retailers': FeaturedRetailersTastic,
  'commercetools/ui/all-retailers': AllRetailersTastic,
  'commercetools/ui/product-list': ProductListTastic,
  'commercetools/ui/search': SearchTastic,
  'commercetools/ui/search-result': SearchResultTastic,
  'commercetools/ui/filter-retailers': FilterRetailersTastic,
  'commercetools/ui/filter-product-list': FilterProductListTastic,
  'commercetools/ui/filter-panel': FilterPanelTastic,
  'commercetools/ui/top-retailers': TopRetailersTastic,
  'commercetools/ui/top-products': TopProductsTastic,
  'commercetools/ui/retailer-parent': RetailerGrandParentTastic,
  'commercetools/ui/retailer-suggestions': RetailerSuggestions,
  'commercetools/ui/grand-parent-retailers-list': GrandParentAllRetailersTastic,
  'commercetools/ui/content/divider': DividerTastic,
  'commercetools/ui/content-banner': ContentBannerTastic,
  'commercetools/ui/category-images': CategoryImagesTastic,
  'commercetools/ui/leasing-steps-content': LeasingStepsContentTastic,
  'commercetools/ui/findEverything': FindEverythingTastic,
  'commercetools/ui/products/promotion-slider': PromotionSliderTastic,
  'commercetools/ui/featured-products': FeaturedProductsTastic,
  'commercetools/ui/LatestFromRetailers': LatestFromRetailerTastic,
  'commercetools/ui/homeSearchBar': HomeSearchBarTastic,
  'commercetools/ui/shopRetailerCategory': ShopRetailerCategoryTastic,
  'commercetools/ui/page-header': PageHeaderTastic,
  'commercetools/ui/products/similar-category-products': SimilarCategoryProducts,
  'commercetools/ui/contentful-blog': ContentfulBlogTastic,
  'commercetools/ui/affiliate-ua-post-approval-loader': AffiliateUAPostApprovalLoaderTastic,
  'commercetools/ui/contentful-preview': ContentfulPreview,
  'commercetools/ui/retailer-handoff-contentful-preview': HandoffContentfulPreview,
  'commercetools/ui/common-featured-retailers': CommonFeaturedRetailersTastic,
  'commercetools/ui/contentful-search-blog': BlogSearchTastic,
  'commercetools/ui/contentful-blog-search': ContentfulBlogSearchTastic,
  'commercetools/ui/blog-container': BlogContainerTastic,
  'commercetools/ui/contentful-retailer-detail-container': RetailerDetailContainerTastic,
  'commercetools/ui/contentful-category-page-container': CategoryPageContainerTastic,
  'commercetools/ui/contentful-blog-search-results': ContentfulBlogSearchResultsTastic,
  'commercetools/ui/contentful-blog-category-page': ContentfulBlogCategoryPageTastic,
  'commercetools/ui/content-container': ContentContainerTastic,
  'commercetools/ui/retailer-handoff-container': RetailerHandoffContainerTastic,
  'commercetools/ui/global-header': GlobalHeaderTastic,
} as TasticRegistry;
